// extracted by mini-css-extract-plugin
export default {"countDown":"sessionModal_countDown__frpbq"};